(function () {
  var RISKY_VARIANTS = {
    '57916085436747': 'Audi A6/S6/RS6 C8 inkl Allroad',
    '57916085469515': 'Audi A7/S7/RS7 C8',
    '57916231549259': 'Audi A8/S8 D5',
    '57916231582027': 'Audi Q7/SQ7 4M',
    '57916231614795': 'Audi Q8/SQ8/RS Q8 4M',
    '57916231647563': 'Audi Q5/SQ5 FY'
  };

  var SFD_KEYS = [
    'SFD2 Kompatibilität bestätigt',
    'SFD2 Hinweis bestätigt für',
    'Bestätigung'
  ];

  var modal;
  var modelText;
  var check;
  var primary;
  var errorText;
  var checkoutBusy = false;
  var bypassCheckout = false;

  function idClean(value) {
    return String(value || '').replace(/[^0-9]/g, '');
  }

  function route(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + String(path || '').replace(/^\/+/, '');
  }

  function isRiskyItem(item) {
    return !!RISKY_VARIANTS[idClean(item && item.variant_id)];
  }

  function riskyItems(cart) {
    return (cart && cart.items ? cart.items : []).filter(isRiskyItem);
  }

  function uniqueModels(items) {
    var seen = {};
    var names = [];
    (items || []).forEach(function (item) {
      var name = RISKY_VARIANTS[idClean(item.variant_id)];
      if (name && !seen[name]) {
        seen[name] = true;
        names.push(name);
      }
    });
    return names;
  }

  function getCart() {
    return fetch(route('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Warenkorb konnte nicht geladen werden.');
      return response.json();
    });
  }

  function stripSfdProperties(properties) {
    var clean = {};
    var source = properties || {};
    Object.keys(source).forEach(function (key) {
      if (SFD_KEYS.indexOf(key) === -1) clean[key] = source[key];
    });
    return clean;
  }

  function hasSfdProperties(item) {
    var props = (item && item.properties) || {};
    return SFD_KEYS.some(function (key) {
      return Object.prototype.hasOwnProperty.call(props, key);
    });
  }

  function expectedProperties(item) {
    var props = stripSfdProperties(item && item.properties);
    props['SFD2 Kompatibilität bestätigt'] = 'Ja';
    props['SFD2 Hinweis bestätigt für'] = RISKY_VARIANTS[idClean(item.variant_id)] || 'ausgewähltes Fahrzeug';
    props.Bestätigung = 'Kunde bestätigt: Fahrzeug besitzt keinen SFD2 / UNECE-Diagnoseschutz.';
    return props;
  }

  function confirmationIsCurrent(item) {
    var props = (item && item.properties) || {};
    return props['SFD2 Kompatibilität bestätigt'] === 'Ja' &&
      props['SFD2 Hinweis bestätigt für'] === RISKY_VARIANTS[idClean(item.variant_id)] &&
      props.Bestätigung === 'Kunde bestätigt: Fahrzeug besitzt keinen SFD2 / UNECE-Diagnoseschutz.';
  }

  function changeProperties(item, properties) {
    return fetch(route('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        properties: properties
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden.');
      return response.json();
    });
  }

  async function cleanupLegacyNonRisky() {
    for (var guard = 0; guard < 20; guard++) {
      var cart = await getCart();
      var target = (cart.items || []).find(function (item) {
        return !isRiskyItem(item) && hasSfdProperties(item);
      });
      if (!target) return cart;
      await changeProperties(target, stripSfdProperties(target.properties));
    }
    return getCart();
  }

  async function persistRiskyConfirmations() {
    for (var guard = 0; guard < 20; guard++) {
      var cart = await getCart();
      var target = riskyItems(cart).find(function (item) {
        return !confirmationIsCurrent(item);
      });
      if (!target) return cart;
      await changeProperties(target, expectedProperties(target));
    }
    throw new Error('Die SFD2-Bestätigung konnte nicht gespeichert werden.');
  }

  function bindModalElements() {
    modelText = modal.querySelector('.dropit-sfd2-model');
    check = modal.querySelector('#dropit-sfd2-confirm-checkbox');
    primary = modal.querySelector('.dropit-sfd2-primary');
    errorText = modal.querySelector('.dropit-sfd2-error');
  }

  function buildModal() {
    var existing = document.getElementById('dropit-sfd2-overlay');
    if (existing && existing.tagName === 'DIALOG') {
      modal = existing;
      bindModalElements();
      return;
    }
    if (existing) existing.remove();

    modal = document.createElement('dialog');
    modal.id = 'dropit-sfd2-overlay';
    modal.className = 'dropit-sfd2-overlay';
    modal.setAttribute('aria-labelledby', 'dropit-sfd2-title');
    modal.innerHTML = '<div class="dropit-sfd2-modal"><div class="dropit-sfd2-modal__head"><h2 id="dropit-sfd2-title">Kompatibilität prüfen</h2><button class="dropit-sfd2-close" type="button" aria-label="Schließen">×</button></div><div class="dropit-sfd2-modal__body"><span class="dropit-sfd2-badge">SFD2 / UNECE Prüfung</span><p>In deinem Warenkorb befindet sich mindestens ein Fahrzeug, das je nach Modelljahr mit SFD2 / UNECE-Diagnoseschutz ausgestattet sein kann:</p><p><strong class="dropit-sfd2-model"></strong></p><p><strong>DropIT! V1 funktioniert bei diesem Fahrzeug nur, wenn:</strong></p><ul><li>dein Fahrzeug originale Audi Luftfederung ab Werk besitzt</li><li>dein Fahrzeug keinen SFD2 / UNECE-Diagnoseschutz hat</li><li>dein Fahrzeug keinen der PR-Codes NI1, NI7, NI8 oder NI9 besitzt</li></ul><p><strong>Kein SFD2-Risiko besteht in der Regel bei Modelljahr 2023 oder älter.</strong></p><p>Ab Modelljahr 2024, teilweise bei Fahrzeugen mit Baujahr ab Mitte 2023, muss die SFD2 / UNECE-Kompatibilität geprüft werden. Fahrzeuge mit PR-Code NI0 gelten nach aktuellem Stand nicht als SFD2 / UNECE-Fahrzeuge.</p><p class="dropit-sfd2-note">Die PR-Codes findest du üblicherweise im Serviceheft oder auf dem Fahrzeugdatenträger im Kofferraum, häufig in der Reserveradmulde oder unter der Kofferraumabdeckung. Zusätzlich kann ein Diagnose-Scan mit „UNECE“ oder „SFD2“ ein Hinweis sein.</p><div class="dropit-sfd2-confirm"><input id="dropit-sfd2-confirm-checkbox" type="checkbox"><label for="dropit-sfd2-confirm-checkbox">Ich habe geprüft, dass mein Fahrzeug kompatibel ist und keinen SFD2 / UNECE-Diagnoseschutz besitzt.</label></div><p class="dropit-sfd2-error" role="alert" hidden></p><div class="dropit-sfd2-actions"><button class="dropit-sfd2-primary" type="button" disabled>Bestätigen und zur Kasse</button><button class="dropit-sfd2-secondary" type="button">Abbrechen</button></div></div></div>';
    document.body.appendChild(modal);
    bindModalElements();

    check.addEventListener('change', function () {
      primary.disabled = !check.checked || checkoutBusy;
    });

    primary.addEventListener('click', async function () {
      if (!check.checked || checkoutBusy) return;
      checkoutBusy = true;
      primary.disabled = true;
      primary.textContent = 'Wird geprüft ...';
      errorText.hidden = true;

      try {
        await cleanupLegacyNonRisky();
        await persistRiskyConfirmations();
        goToCheckout();
      } catch (error) {
        checkoutBusy = false;
        primary.textContent = 'Bestätigen und zur Kasse';
        primary.disabled = !check.checked;
        errorText.textContent = 'Die Bestätigung konnte nicht gespeichert werden. Bitte versuche es erneut.';
        errorText.hidden = false;
      }
    });

    modal.querySelector('.dropit-sfd2-close').addEventListener('click', closeModal);
    modal.querySelector('.dropit-sfd2-secondary').addEventListener('click', closeModal);

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      if (!checkoutBusy) closeModal();
    });
  }

  function openModal(items) {
    buildModal();
    var names = uniqueModels(items);
    modelText.textContent = names.join(', ') || 'ausgewähltes Fahrzeug';
    check.checked = false;
    primary.disabled = true;
    primary.textContent = 'Bestätigen und zur Kasse';
    errorText.hidden = true;

    if (!modal.open) {
      try {
        modal.showModal();
      } catch (error) {
        modal.setAttribute('open', '');
      }
    }
    document.body.classList.add('dropit-sfd2-body-lock');
  }

  function closeModal() {
    if (!modal || checkoutBusy) return;
    if (modal.open) {
      try {
        modal.close();
      } catch (error) {
        modal.removeAttribute('open');
      }
    }
    document.body.classList.remove('dropit-sfd2-body-lock');
  }

  function goToCheckout() {
    bypassCheckout = true;
    window.location.assign(route('checkout'));
  }

  async function handleCheckout() {
    if (checkoutBusy) return;
    checkoutBusy = true;

    try {
      var cart = await cleanupLegacyNonRisky();
      var affected = riskyItems(cart);
      if (!affected.length) {
        goToCheckout();
        return;
      }
      checkoutBusy = false;
      openModal(affected);
    } catch (error) {
      checkoutBusy = false;
      buildModal();
      openModal([]);
      modelText.textContent = 'Warenkorb konnte nicht geprüft werden';
      errorText.textContent = 'Bitte lade die Seite neu und versuche es erneut.';
      errorText.hidden = false;
    }
  }

  function blockCheckoutEvent(event) {
    if (bypassCheckout) return false;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    handleCheckout();
    return true;
  }

  function watchCheckout() {
    document.addEventListener('click', function (event) {
      if (bypassCheckout) return;
      var target = event.target && event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"], #checkout, a[href="/checkout"], a[href$="/checkout"]');
      if (!target) return;
      blockCheckoutEvent(event);
    }, true);

    document.addEventListener('submit', function (event) {
      if (bypassCheckout) return;
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      blockCheckoutEvent(event);
    }, true);
  }

  function init() {
    buildModal();
    watchCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();